import React from 'react';
import { ImageBackground } from 'expo-image';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export const HomeHeroImageXS = (props: HomeHeroImageXSProps) => {
  const { children, imageUrl, imageA11yLabel, dataSet } = props;

  return (
    <ImageBackground
      contentFit="cover"
      accessibilityLabel={imageA11yLabel}
      source={imageUrl}
      style={styles.imageBackground}
      {...(dataSet ? { dataSet } : {})}
    >
      <SafeAreaView edges={['top']}>{children}</SafeAreaView>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  imageBackground: { flexGrow: 1 },
});

type HomeHeroImageXSProps = {
  children: React.ReactNode;
  imageUrl: string;
  imageA11yLabel: string;
  dataSet?: Record<string, string>;
};
